import { defaultIconProps, IconProps } from './IconProps';

export const IconStackLayout: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M10 10L19 10M10 1L10 19M5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const IconStackLayout: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
//   <svg width={size} height={size} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
//     <g>
//       <rect stroke={color} id="svg_2" strokeWidth="2" height="12" width="16" y="1" x="1" rx="3" ry="3" />
//       <rect stroke={color} id="svg_3" strokeWidth="2" height="12" width="8" y="1" x="20" rx="3" ry="3" />
//       <rect stroke={color} id="svg_4" strokeWidth="2" height="12" width="16" y="16" x="12" rx="3" ry="3" />
//       <rect stroke={color} id="svg_5" strokeWidth="2" height="12" width="8" y="16" x="1" rx="3" ry="3" />
//     </g>
//   </svg>
// );

IconStackLayout.defaultProps = defaultIconProps;
